import type { CardFieldElementType } from '../types/elements';
import type {
  CardCollectionFieldErrorType,
  CardCollectionMessages,
} from './card-collection-provider';

export type CardFieldCopy = {
  locale: string;
  ariaLabel: string;
  placeholder: string;
  errors: Record<CardCollectionFieldErrorType, string>;
};

/**
 * Convert the versioned Hosted Checkout message projection into the copy for
 * one SDK-owned field. Translation text is distributed by Hosted Checkout;
 * the SDK contains only the stable translation-key mapping.
 */
export function resolveCardFieldCopy(
  type: CardFieldElementType,
  messages: CardCollectionMessages,
  locale: string,
): CardFieldCopy {
  const card = messages.card;
  switch (type) {
    case 'cardNumber':
      return {
        locale,
        ariaLabel: card.cardNumber,
        placeholder: card.cardNumberPlaceholder,
        errors: { ...card.errors.number },
      };
    case 'cardExpiry':
      return {
        locale,
        ariaLabel: card.expirationDate,
        placeholder: card.expirationDatePlaceholder,
        errors: { ...card.errors.expirationDate },
      };
    case 'cardCvc':
      return {
        locale,
        ariaLabel: card.securityCode,
        placeholder: card.cvvPlaceholder,
        errors: { ...card.errors.cvv },
      };
  }
}
